import { createFileRoute, Outlet } from "@tanstack/react-router";
import { guardOwnFeature } from "@/lib/policy/route-guard";

/** Your own shifts need no permission, only the module: the API asks nothing more either. */
export const Route = createFileRoute("/_authenticated/you/shifts")({
  beforeLoad: ({ context }) => guardOwnFeature(context.me, "schedule"),
  component: Outlet,
});
